import Statement from "@components/statement/Statement";
import { FaCheck } from "react-icons/fa6";
import { Checkbox, Label, XStack } from "tamagui";
import type { CheckboxProps } from "tamagui";

type DataProps = {
  id: string;
  label: string;
  statement?: {
    need: boolean;
    title?: string;
  };
};

type CheckboxItemProps = CheckboxProps & {
  data: DataProps;
  value?: boolean | string;
  onChange?: (checked: boolean) => void;
};

export function CheckboxItem({ data, value, onChange, checked }: CheckboxItemProps) {
  const isChecked = checked !== undefined ? checked : !!value;
  return (
    <XStack alignItems="center" gap="$4" style={{ alignItems: "center" }}>
      <Checkbox id={data?.id} size="$4" checked={isChecked} onCheckedChange={onChange}>
        <Checkbox.Indicator>
          <FaCheck />
        </Checkbox.Indicator>
      </Checkbox>
      <div className="flex items-center flex-wrap">
        <div className="flex items-center">
          <span style={{ fontSize: "18px", color: "#e20000", marginRight: "5px" }}>*</span>
          <Label size="$5" htmlFor={data?.id} style={{ whiteSpace: "nowrap" }}>
            {data?.label}
          </Label>
        </div>
        {data?.statement?.need && <Statement title={data?.statement?.title || ""} />}
      </div>
    </XStack>
  );
}
